import * as React from "react";
import { Layout } from 'antd';

const { Footer } = Layout;

export default () => (
    <Footer style={{ textAlign: 'center' }}>Copyright © 2023</Footer>
)
